module.exports = __webpack_public_path__ + "svg/new-mastercard-big.636a4c0effc7429f9ec08d8e81788f92.svg";